//------------------------------------------------------------------------
// Notice for international shipping
//-----------------------------------------------------------------------

export default class ShippingNotice {
  constructor(el) {
    this.el = el;
    // Get the country select field based on the class of the parent element
    this.countrySelect = this.el.classList.contains('woocommerce-shipping-fields')
      ? this.el.querySelector('#shipping_country')
      : this.el.querySelector('#billing_country');
    this.shipToDifferentAddress = document.querySelector('#ship-to-different-address-checkbox');
    
    if (!this.countrySelect) return; // bail if no country select
    
    this.applyShippingNotice(); // check on page load

    // listen for changes to the country select
    $(this.countrySelect).on('change', () => {
      this.applyShippingNotice();
    });

    // listen for changes to the ship to different address checkbox
    if (this.shipToDifferentAddress) {
      $(this.shipToDifferentAddress).on('change', () => {
        this.applyShippingNotice();
      });
    }
  }

  // Check if the country selects are set to US, and show a notice if they aren't
  applyShippingNotice() {
    const noticeClass = 'shipping-notice';
    let notice = this.el.querySelector(`.${noticeClass}`);
    let shippingFieldsExposed = this.shipToDifferentAddress && this.shipToDifferentAddress.checked // check if shipping fields are exposed

    // Show the notice on the shipping select field if shipping fields are exposed, or on the billing select field if they aren't
    if ((this.countrySelect.value !== 'US' && this.countrySelect.id === "shipping_country" && shippingFieldsExposed) || (this.countrySelect.value !== 'US' && !shippingFieldsExposed)) {
      // add an after element to the country select if there isn't one already
      if (!this.el.querySelector('.shipping-notice')) {
        // Create notice only if it doesn't already exist
        notice = document.createElement('p');
        notice.classList.add(noticeClass);
        notice.textContent = 'International shipments may experience Customs delays, taxes, or fees. Please be aware that Customs may require additional information before your package can be released. The O’Keeffe Museum is not responsible for any duties, taxes, or tariffs upon delivery. Should Customs return your package to us, we will refund the item cost, though shipping costs may not be refundable.';
        this.countrySelect.insertAdjacentElement('afterend', notice);
      }
    } else {
      // Remove notices if shipping in the US
      if (notice) notice.remove();
    }
  }
}

// Init
document.querySelectorAll('.woocommerce-billing-fields, .woocommerce-shipping-fields').forEach((el) => {
  new ShippingNotice(el);
});